import { render, staticRenderFns } from "./ProductDetailsForm.vue?vue&type=template&id=650f416a&scoped=true&"
import script from "./ProductDetailsForm.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailsForm.vue?vue&type=style&index=0&id=650f416a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650f416a",
  null
  
)

export default component.exports